import { render, staticRenderFns } from "./ChooseAddress.vue?vue&type=template&id=c7bc064e&"
import script from "./ChooseAddress.vue?vue&type=script&lang=js&"
export * from "./ChooseAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports